import type { Order } from '@seen/core/models/orders/Order'
import { compact } from 'lodash-es'
import { extractTextFromHTML } from '#src/utils/html.ts'

type OrderTitleReturn<T extends Order | undefined> = T extends undefined
  ? undefined
  : string

export function getOrderTitle<T extends Order | undefined>(
  order: T
): OrderTitleReturn<T> {
  if (!order) {
    return undefined as OrderTitleReturn<T>
  }

  if (order.title) {
    return extractTextFromHTML(order.title) as OrderTitleReturn<T>
  }

  const detail = order?.orderDetailsText ?? ''
  const reason = order?.reasonTexts.join(', ') ?? ''
  const specialty = order?.specialty?.display ?? ''
  return extractTextFromHTML(
    compact([specialty, reason, detail]).join(', ')
  ) as OrderTitleReturn<T>
}
